module.exports = __webpack_public_path__ + "img/icon_suspend.de8a0d3f.png";